import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton
} from 'shared/components/common/modal/Modal'
import { t } from 'src/translations'
import { getImageUrl } from 'shared/components/common/Image'

type CommunityHighlightsModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const CommunityHighlightsModal = ({
  isOpen,
  onClose
}: CommunityHighlightsModalProps) => {
  const imageSrc = getImageUrl('admin/community-highlights.svg')

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className='chModal'
      testId='community-highlights-modal'
    >
      <ModalOverlay fadeIn fadeOut />
      <ModalContent
        fadeIn
        wrapperClassName='chModalWrapper'
        contentClassName='chModalContent'
        ariaLabelledBy='community-highlights-modal-title'
      >
        <ModalCloseButton />
        <h2
          id='community-highlights-modal-title'
          className='chModalTitle'
          tabIndex={-1}
        >
          {t('reviews.community-highlights-modal-title')}
        </h2>
        <p className='chModalDescription'>
          {t('reviews.community-highlights-modal-description')}
        </p>
        <img
          src={imageSrc}
          alt=''
          aria-hidden='true'
          className='chModalIllustration'
        />
        <p className='chModalFeaturesTitle'>
          {t('reviews.community-highlights-modal-reviews-are')}
        </p>
        <div className='chModalFeature'>
          <strong>{t('reviews.community-highlights-modal-authentic')}</strong>{' '}
          {t('reviews.community-highlights-modal-authentic-description')}
        </div>
        <div className='chModalFeature'>
          <strong>{t('reviews.community-highlights-modal-positive')}</strong>{' '}
          {t('reviews.community-highlights-modal-positive-description')}
        </div>
        <div className='chModalFeature'>
          <strong>{t('reviews.community-highlights-modal-helpful')}</strong>{' '}
          {t('reviews.community-highlights-modal-helpful-description')}
        </div>
      </ModalContent>
    </Modal>
  )
}
